import { createContext, useState } from "react";
import { useEffect } from "react";
import coinGecko from "../api/coinGecko";

export const WatchListContext=createContext();


export default function WatchListContextProvider({children}){
    const [watchList, setWatchList] = useState(
        localStorage.getItem("watchList")?.split(",") || [
          "bitcoin",
          "ethereum",
          "ripple",
          "litecoin",
        ]
      );

      useEffect(() => {
        localStorage.setItem("watchList", watchList);
      }, [watchList]);

      const deleteCoin = (coin) => {
        setWatchList(
          watchList.filter((el) => {
            return el !== coin;
          })
        );
      };
    
      const addCoin = (coin) => {
        if (watchList.indexOf(coin) === -1) {
          setWatchList([...watchList, coin]);
        }
      };
        // --------------------------History Chart js-------------------------------------
        const [coinData, setCoinData] = useState({});
        const [isLoading, setIsLoading] = useState(false);
        const [id ,setid]=useState(watchList[0]);
        
          const formatData = (data) => {
            return data.map((el) => {
              return {
                t: el[0],
                y: el[1].toFixed(2),
              };
            });
          };
          const fetchdata = async () => {
            setIsLoading(true);
            try {
              const [day, week, year, detail] = await Promise.all([
                coinGecko.get(`/coins/${id}/market_chart/`, {
                  params: {
                    vs_currency: "usd",
                    days: "1",
                  },
                }),
                coinGecko.get(`/coins/${id}/market_chart/`, {
                  params: {
                    vs_currency: "usd",
                    days: "7",
                  },
                }),
                coinGecko.get(`/coins/${id}/market_chart/`, {
                  params: {
                    vs_currency: "usd",
                    days: "365",
                  },
                }),
                coinGecko.get("/coins/markets/", {
                  params: {
                    vs_currency: "usd",
                    ids: id,
                  },
                }),
              ]);
        
              setCoinData({
                day: formatData(day.data.prices),
                week: formatData(week.data.prices),
                year: formatData(year.data.prices),
                detail: detail.data[0],
              });
              console.log("coindetailpagedata: ", coinData);
              console.log("dayData:",day);
              console.log("yearData:",year);
              console.log("weekData:",week);
              console.log("detailData:",detail);
            }
            catch(error){
              console.log("Error Fetching Data", error);
            }
            finally {
              setIsLoading(false);
            }
          };
        
          useEffect(() => {
            if(id)
            fetchdata(id);
          }, [id]);

//------------------------------------- Endpoint is here ----------------------------

    const value={
        watchList, 
        deleteCoin,
        addCoin ,
        fetchdata,
        setid,
        coinData,
    };
    return <WatchListContext.Provider value={value} >
        {children}
        </WatchListContext.Provider>; 
}
